import { useState } from "react";
import { LockFill } from "react-bootstrap-icons";
import { closeTicket, replyTicket } from "../../services/TicketService";
import { TicketMessage } from "./TicketMessage";
import { FormFeedback } from "../FormFeedback";

export function TicketBody({ messages: initialMessages, status: initialStatus, id }) {
  const [messages, setMessages] = useState(initialMessages);
  const [status,   setStatus]   = useState(initialStatus);
  const [reply,    setReply]    = useState('');
  const [sending,  setSending]  = useState(false);
  const [closing,  setClosing]  = useState(false);
  const [error,    setError]    = useState(null);

  const isClosed = status === 'Closed';
  const busy     = sending || closing;

  async function handleReply() {
    if (!reply.trim()) { setError('Please write a reply before submitting.'); return; }
    setError(null);
    setSending(true);
    try {
      const newMessage = await replyTicket(id, reply);
      setMessages(prev => [...prev, newMessage]);
      setReply('');
    } catch (err) {
      setError(err.message || 'Failed to send reply. Please try again.');
    } finally {
      setSending(false);
    }
  }

  async function handleClose() {
    setError(null);
    setClosing(true);
    try {
      await closeTicket(id);
      setStatus('Closed');
    } catch (err) {
      setError(err.message || 'Failed to close the ticket. Please try again.');
    } finally {
      setClosing(false);
    }
  }

  return (
    <>
      <div className="tv-thread">
        {messages.map((msg, i) => (
          <TicketMessage key={i} message={msg} />
        ))}
      </div>

      <div className="tv-reply">
        {isClosed ? (
          <p className="tv-closed-notice">
            <LockFill aria-hidden="true" />
            This ticket is closed and can no longer receive replies.
          </p>
        ) : (
          <>
            <div className="tv-reply-header">Reply</div>
            <div className="tv-reply-body">
              <textarea
                className="tv-textarea"
                placeholder="Write your reply…"
                value={reply}
                onChange={e => setReply(e.target.value)}
                disabled={busy}
              />
              <FormFeedback type="error" message={error} />
              <div className="tv-reply-actions">
                <button
                  className="tv-btn-reply"
                  type="button"
                  onClick={handleReply}
                  disabled={busy}
                >
                  {sending ? 'Sending…' : 'Reply'}
                </button>
                <button
                  className="tv-btn-close"
                  type="button"
                  onClick={handleClose}
                  disabled={busy}
                >
                  {closing ? 'Closing…' : 'Close Ticket'}
                </button>
              </div>
            </div>
          </>
        )}
      </div>
    </>
  );
}
